if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.desktop = window.matchMedia('(min-width: 750px)');
        this.scroller = this.querySelector('[role="document"]');
        this.scroller?.addEventListener('click', this.onScrollerClick.bind(this));
      }

      hide() {
        super.hide();
      }

      show(opener) {
        this.unwrapMedia();
        super.show(opener);
        this.showActiveMedia();
      }

      // Media list ships template-wrapped so hidden modal images stay inert
      // until the zoom modal actually opens.
      unwrapMedia() {
        this.querySelectorAll('template[data-product-modal-media]').forEach((tpl) => {
          tpl.replaceWith(tpl.content.cloneNode(true));
        });
      }

      onScrollerClick(event) {
        if (!this.desktop.matches) return;
        if (event.target.closest('deferred-media, product-model, button')) return;
        this.hide();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        // Desktop stacks every image full-bleed in one vertical scroller, so land on
        // the clicked image's top edge instead of letting scrollIntoView centre it.
        if (this.desktop.matches && this.scroller) {
          this.scroller.scrollTop = activeMedia.offsetTop;
        } else {
          activeMedia.scrollIntoView({ behavior: 'instant' });
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
